import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Container, Row, Col, useScreenClass } from 'react-grid-system'
import { Link as RouterLink } from 'react-router-dom'
import { InteractiveButton, TextField, Link, Heading1, Heading3 } from 'adl'
import LogoCard from 'components/LogoCard'

const HeroSection = styled.section`
  background-image: url(${props => props.theme.branding.marketingImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 100%;

  &::before {
    background: ${props =>
      props.small
        ? 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))'
        : 'linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))'};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`

function SignInPage({ history }) {
  const dispatch = useDispatch()
  const screenClass = useScreenClass()

  return (
    <HeroSection small={['xs', 'sm'].includes(screenClass)}>
      <Container>
        <Row align={'center'}>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={7}
            style={{ paddingTop: 32, paddingBottom: 32 }}
          >
            <Heading1 style={{ color: 'white' }}>
              Marketing Starts Here.
            </Heading1>
            <p style={{ color: '#ddd' }}>
              These messages can have quite an impact. So we keep them short,
              and sweet.
            </p>
          </Col>
          <Col xs={12} sm={12} md={6} lg={5}>
            <LogoCard
              style={{ maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}
            >
              <Heading3 style={{ marginBottom: 16, textAlign: 'center' }}>
                Sign In
              </Heading3>

              <TextField
                tabIndex={'1'}
                label="Username"
                style={{ marginBottom: '0.5rem' }}
              />
              <TextField
                tabIndex={'2'}
                type="password"
                label="Password"
                style={{ marginBottom: '1rem' }}
              />
              <InteractiveButton
                tabIndex={'3'}
                onClick={() => {
                  dispatch({
                    type: 'USER_LOGIN_SUCCESS'
                  })
                  history.replace('/accounts')
                }}
                block
                style={{ marginBottom: '2rem' }}
              >
                Sign In
              </InteractiveButton>

              <div style={{ textAlign: 'center' }}>
                <Link as={RouterLink} to="/trouble-signing-in" tabIndex={'4'}>
                  Trouble Signing In?
                </Link>
                <div>
                  Need an account?{' '}
                  <Link as={RouterLink} tabIndex={'5'} to="/sign-up">
                    Sign Up
                  </Link>
                </div>
              </div>
            </LogoCard>
          </Col>
        </Row>
      </Container>
    </HeroSection>
  )
}

export default SignInPage
